var _g, _g2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftGridImage1440(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 594,
    viewBox: "0 0 501 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.4297,
    y1: 10.1602,
    x2: 42.4297,
    y2: 506.805,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0938,
    y1: 2.17306e-8,
    x2: 84.0937,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.766,
    y1: 2.17306e-8,
    x2: 125.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.43,
    y1: 2.17306e-8,
    x2: 167.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.094,
    y1: 2.17306e-8,
    x2: 209.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.766,
    y1: 2.17306e-8,
    x2: 250.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.43,
    y1: 2.17306e-8,
    x2: 292.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.094,
    y1: 2.17306e-8,
    x2: 334.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.766,
    y1: 2.17306e-8,
    x2: 375.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.43,
    y1: 2.17306e-8,
    x2: 417.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.094,
    y1: 2.17306e-8,
    x2: 459.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 40.2852,
    x2: -0.00366215,
    y2: 40.2851,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 82.7188,
    x2: -0.00366215,
    y2: 82.7187,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 125.148,
    x2: -0.00366215,
    y2: 125.148,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 167.582,
    x2: -0.00366215,
    y2: 167.582,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 210.012,
    x2: -0.00366215,
    y2: 210.012,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 252.445,
    x2: -0.00366215,
    y2: 252.445,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 294.875,
    x2: -0.00366215,
    y2: 294.875,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 337.309,
    x2: -0.00366215,
    y2: 337.309,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 379.742,
    x2: -0.00366215,
    y2: 379.742,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 422.172,
    x2: -0.00366215,
    y2: 422.172,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 464.605,
    x2: -0.00366215,
    y2: 464.605,
    stroke: "#7551FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1359_22735)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.943,
    cy: 455.042,
    rx: 68.5043,
    ry: 145.347,
    transform: "rotate(124.141 203.943 455.042)",
    fill: "url(#paint0_linear_1359_22735)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 403.781,
    cy: 308.531,
    r: 1.78137,
    fill: "#7551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1359_22735",
    x: 75.8124,
    y: 353.887,
    width: 256.258,
    height: 202.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1359_22735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1359_22735",
    x1: 158.585,
    y1: 325.331,
    x2: 217.744,
    y2: 598.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGridImage1440);
export default __webpack_public_path__ + "static/media/LeftGridImage1440.129a191010d4c5b1582251b6564edaf8.svg";
export { ForwardRef as ReactComponent };